import Head from 'next/head';
import React from 'react';
import { connectInfiniteHits, InfiniteHitsProvided } from 'react-instantsearch-core';
import { usePage } from '~/templates/pages';

type Props = InfiniteHitsProvided & {
    currentPage: number;
};

export const CustomTrackingRelNext = ({ hasMore, hasPrevious, currentPage }: Props) => {
    const page = usePage();
    const previousPage = hasPrevious ? `${page.url}?page=${currentPage - 1}` : null;
    const nextPage = hasMore ? `${page.url}?page=${currentPage + 1}` : null;
    const paginationCanonical = hasPrevious ? `${page.url}?page=${currentPage}` : null;

    return (
        <Head>
            {previousPage ? <link rel="prev" href={previousPage} /> : null}
            {nextPage ? <link rel="next" href={nextPage} /> : null}
            {paginationCanonical ? (
                <link key="canonical" rel="canonical" href={paginationCanonical} />
            ) : null}
        </Head>
    );
};

export const TrackingRelNext = connectInfiniteHits(CustomTrackingRelNext);
